import React from "react";
import Radio from "antd/lib/radio";
import {
  SurveyQuestionCard,
  SymptomAlertCard,
  AnswerList,
  AnswerOption,
  FormItemStyle,
  AsteriskStyle,
  CardTitle
} from "pages/symptoms/surveyForms/surveyFormComponents";

interface ShortnessOfBreathSectionProps {
  readonly currentPage: number;
}

export const ShortnessOfBreathSection: React.FC<
  ShortnessOfBreathSectionProps
> = ({ currentPage }) => {
  return (
    <>
      {currentPage === 10 && (
        <SurveyQuestionCard
          sectionTag="SHORTNESS OF BREATH"
          title="Have you had any shortness of breath during dialysis recently?"
          required
        >
          <FormItemStyle
            name="Have you had any shortness of breath"
            label=""
            rules={[{ required: true }]}
            initialValue={""}
          >
            <Radio.Group
              value={localStorage.getItem("haveYouHadShortnessOfBreath")}
              onChange={e => {
                localStorage.setItem(
                  "haveYouHadShortnessOfBreath",
                  e.target.value
                );
              }}
            >
              <AnswerList>
                <AnswerOption value="None">None</AnswerOption>
                <AnswerOption value="Rarely (1 - 2 / Month)">
                  Rarely (1 - 2 / Month)
                </AnswerOption>
                <AnswerOption value="Occasional (3 - 4 / Month)">
                  Occasional (3 - 4 / Month)
                </AnswerOption>
                <AnswerOption value="Frequent (5 - 10 / Month)">
                  Frequent (5 - 10 / Month)
                </AnswerOption>
                <AnswerOption value="Every dialysis (11 - 13 / Month)">
                  Every dialysis (11 - 13 / Month)
                </AnswerOption>
              </AnswerList>
            </Radio.Group>
          </FormItemStyle>
        </SurveyQuestionCard>
      )}
      {currentPage === 11 && (
        <SymptomAlertCard message="Please be sure to discuss your symptoms of shortness of breath with your nurse or doctor" />
      )}
    </>
  );
};
